<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="flex flex-col lg:flex-row lg:justify-center items-center px-6 py-16 md:py-20 md:px-16 lg:px-10 xl:px-0   lg:py-24 xl:py-28 col-span-full md:col-start-1 md:col-end-9 lg:col-start-1 lg:col-end-13 xl:col-start-1 xl:col-end-12 xl:ml-159px gap-y-12"
    >
      <section class="w-full xl:pr-14">
        <p class="text-3xl md:max-w-100 lg:text-5xl lg:max-w-109 xl:max-w-full leading-none lg:leading-14.75 pr-9 md:pr-0" v-text="banner.bigTitle" :class="banner.TextsStyles" />
        <p
          :class="banner.TextsStyles"
          class="pt-6 text-lg"
          v-text="banner.bigText" 
        />
        <section @click="toTop" class="pt-6 flex justify-center lg:justify-start">
          <main-button :text="banner.buttonText" :class="banner.buttonStyles" />
        </section>
      </section>
      <section v-if="!isMobile" class="w-full flex flex-col pl-54">
        <section class="w-full flex flex-row pb-20 gap-x-12">

            <article class=" lg:border-none border-black  lg:pt-0 ">
                <p class="font-bold text-xl" v-text="banner.firstTitle" :class="banner.TextsStyles" />
                <p class="text-lg pt-3.5" v-text="banner.firstText" :class="banner.TextsStyles" />
            </article>
            <article class="  lg:border-none border-black pt-16.1 lg:pt-0">
                <p class="font-bold text-xl " v-text="banner.secondTitle" :class="banner.TextsStyles" />
                <p class="text-lg pt-3.5" v-text="banner.secondText" :class="banner.TextsStyles" />
            </article>
        </section>
        <section class="w-full flex flex-row gap-x-12">

            <article class="lg:border-none border-black  ">
                <p class="font-bold text-xl " v-text="banner.thirdTitle" :class="banner.TextsStyles" />
                <p class="text-lg pt-3.5" v-text="banner.thirdText" :class="banner.TextsStyles" />
            </article>
            <article class=" ">
                <p class="font-bold text-xl " v-text="banner.quarteTitle" :class="banner.TextsStyles" />
                <p class="text-lg pt-3.5" v-text="banner.quarteText" :class="banner.TextsStyles" />
            </article>
        </section>
      </section>

      <section v-if="isMobile" class="w-full">

            <section class="flex flex-col md:flex-row gap-y-14 px-10 md:px-0 pb-16 md:pb-20  gap-x-14">
              <article class="lg:w-60">
                  <p class="font-bold text-xl" v-text="banner.firstTitle" :class="banner.TextsStyles" />
                  <p class="text-lg pt-3.5" v-text="banner.firstText" :class="banner.TextsStyles" />
              </article>
              <article class="lg:w-60">
                  <p class="font-bold text-xl " v-text="banner.secondTitle" :class="banner.TextsStyles" />
                  <p class="text-lg pt-3.5" v-text="banner.secondText" :class="banner.TextsStyles" />
              </article>
            </section>
            <section class="flex flex-col md:flex-row px-10 md:px-0 gap-y-14 gap-x-14">
              <article class="lg:w-60">
                  <p class="font-bold text-xl" v-text="banner.firstTitle" :class="banner.TextsStyles" />
                  <p class="text-lg pt-3.5" v-text="banner.firstText" :class="banner.TextsStyles" />
              </article>
              <article class="lg:w-60">
                  <p class="font-bold text-xl " v-text="banner.secondTitle" :class="banner.TextsStyles" />
                  <p class="text-lg pt-3.5" v-text="banner.secondText" :class="banner.TextsStyles" />
              </article>
            </section>
        
      </section>
    </section>
  </section>
</template>
<script>
import utilsMixin from "../mixins/utilsMixin"
import MainButton from "../components/MainButton.vue";
export default {
  mixins: [utilsMixin],
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
  },
  components:{
    MainButton
  },
  methods:{
      handleScroll: function () {
          if (this.scTimer) return;
          this.scTimer = setTimeout(() => {
            this.scY = window.scrollY;
            clearTimeout(this.scTimer);
            this.scTimer = 0;
          }, 100);
     },
     toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
     }
  },
  props:{
    withBorder:{
      default: true
    },
   banner:{
     default: null
   }
  }
};
</script>
